import { render, staticRenderFns } from "./EaseBusiness.vue?vue&type=template&id=507bebbb&scoped=true"
import script from "./EaseBusiness.vue?vue&type=script&lang=js"
export * from "./EaseBusiness.vue?vue&type=script&lang=js"
import style0 from "./EaseBusiness.vue?vue&type=style&index=0&id=507bebbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507bebbb",
  null
  
)

export default component.exports